import { ReactElement } from 'react'
import { Button, Text } from '../atoms'
import { useKeyboardControls } from '../../contexts/KeyboardControlsContext'
import { ControlHighlight, KeyboardControl } from '../molecules/KeyboardControls'
import { HighlightEffect } from '../../enums/KeyboardControls'

interface AnonymityCertificationProps {
  onContinue: () => void
}

const certificationParagraphs = [
  'DopaGE certifies that responses to the following anonymous survey are truly & completely anonymous. For this reason, the 5-minute survey must be completed all at once. If you leave the survey partway through, you will have to restart it when you return.',
  'Responses to this anonymous survey cannot be traced back to the individual respondent - No personally identifiable information is captured from you or from your device during this survey.',
  'Individual responses will be combined with those of many other individuals and summarized in a report for research purposes.',
  'Thank you for your honest responses throughout this short survey to support the advancement of effective overdose prevention education.'
]

const kbControlsLayer = 'survey'
const buttonId = 'certification-next-button'

function AnonymityCertification ({ onContinue }: AnonymityCertificationProps): ReactElement {
  const keyboardControls = useKeyboardControls()

  return (
    <div className='flex flex-col h-full' role='region' aria-labelledby='cert-heading'>
      <h2 className='sr-only' id='cert-heading'>Anonymity Certification</h2>
      <div className='flex-1 flex flex-col'>
        {certificationParagraphs.map((paragraph, index) => (
          <Text
            key={index}
            text={paragraph}
            size='SM'
            className='text-dopage-lightGreen mb-6'
          />
        ))}
      </div>

      <div className='flex justify-center'>
        <ControlHighlight
          active={keyboardControls.isEnabled && keyboardControls.isElementFocused(buttonId)}
          highlightEffect={HighlightEffect.ButtonHexOutline}
        >
          <KeyboardControl layer={kbControlsLayer}>
            <Button
              id={buttonId}
              onClick={onContinue}
              variant='outlined'
              aria-label='Accept and Continue'
              className='px-8 py-3 font-semibold'
            >
              <span>NEXT →</span>
            </Button>
          </KeyboardControl>
        </ControlHighlight>
      </div>
    </div>
  )
}

export default AnonymityCertification
